import { render, staticRenderFns } from "./BlockSmall.vue?vue&type=template&id=fad3fcdc&scoped=true"
import script from "./BlockSmall.vue?vue&type=script&lang=js"
export * from "./BlockSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad3fcdc",
  null
  
)

export default component.exports